import { useEffect, useState } from 'react'

import { ChartColumnDecreasing } from 'lucide-react'
import { DefaultSheet, DefaultTooltip, SheetBody } from 'twyne-new.ui'

import { ReportDatePicker } from 'components/reports/header'

import { useBucketReportStore } from '../store'

import ModalChartContent from './ModalChartContent'

export function getBucketLabel(row) {
  if (row?.subidKey) {
    return `[#${row?.id}] Subid Bucket [${row?.subidKey}]`
  }
  return `[#${row?.id}] Allocation Bucket`
}

export default function RowChartModal({ row, startDate, endDate }) {
  const { chartModal: { open } } = useBucketReportStore()

  const handleOpen = e => {
    e.stopPropagation()
    open({ row, startDate, endDate })
  }

  return <DefaultTooltip content='Show bucket chart' side='left'>
    <button type='button' className='action' onClick={handleOpen}>
      <ChartColumnDecreasing size={16} className='twy-text-accent' />
    </button>
  </DefaultTooltip>
}

export function RowChartModalHost() {
  const { chartModal: { item, close } } = useBucketReportStore()
  const isOpen = !!item
  const { row } = item || {}
  const title = getBucketLabel(row)
  const [dateRange, setDateRange] = useState({})

  useEffect(() => {
    if (item) setDateRange({ startDate: item.startDate, endDate: item.endDate })
  }, [item])

  const handleOpenChange = nextOpen => {
    if (!nextOpen) close()
  }

  return (
    <DefaultSheet
      title={<>
        <span className="flex items-center gap-2">
          {title}
        </span>
        <div className="text-base! absolute right-12 top-1/2 -translate-y-1/2" onClick={e => e.stopPropagation()}>
          <ReportDatePicker dates={dateRange} onChange={setDateRange} size='lg' />
        </div>
      </>}
      contentProps={{
        className: 'w-[130vh] h-[calc(100vh-5rem)]',
      }}
      wrapperProps={{ open: isOpen, onOpenChange: handleOpenChange }}
      trigger={<span className="hidden" />}
    >
      <SheetBody className="overflow-y-auto">
        {row ? <ModalChartContent row={row} startDate={dateRange.startDate} endDate={dateRange.endDate} /> : null}
      </SheetBody>
    </DefaultSheet>
  )
}
